// extracted by mini-css-extract-plugin
export default {"gbutton":"GButton_gbutton__R0Ciy","icon":"GButton_icon__9Kjwf"};